import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardRedirectFb implements CanActivate {

  constructor(
    private router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    const that = this;

    return new Promise(function (resolve) {


      resolve(true);

      // if (next.queryParams.mode && next.queryParams.oobCode && next.queryParams.mode) {
      //   resolve(true);
      // } else {
      //   resolve(false);
      // }

    });
  }

}
